import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 7B600593-08CB-42D0-B106-0EDF12132BFC
 * name diving-scuba-flag
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/diving-scuba-flag.svg
 * tags
 */
export const DivingScubaFlagIcon = createSvgIcon(<><path d="M2,6L19,20H2V6M5,4L22,18V4H5Z" /></>, 'DivingScubaFlagIcon');
export default DivingScubaFlagIcon